<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>DataTables</h1>
					<p waBody="m" waText>DataTables.net 2.3.8 &mdash; advanced interactive HTML tables with multi-column sorting, filtering, pagination, AJAX server-side processing, responsive layouts, export buttons &#40;PDF/Excel/CSV&#41;, search panes, row grouping, virtual scrolling, and dozens of extensions with type-safe Java options.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">DataTables 2.3.8</wa-tag>
						<wa-tag pill variant="neutral">jQuery 4.0.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:data-tables</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.datatable</p>
					<p waBody="s" waText>Built on: DataTables.net 2.3.8</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_554" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_555" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_556" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;6&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DataTable</h4>
								<p waBody="s" waColorText="quiet" waText>Core DataTable component &mdash; wraps an HTML table with DataTables.net initialization, JSON-serializable options, and Angular integration</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">5 props</wa-tag>
									<wa-tag pill variant="neutral">5 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/datatables/data-table']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DataTablePageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>Auto-registers DataTables.net NPM dependencies &#40;datatables.net, jszip, pdfmake&#41;</p>
								<div class="wa-cluster wa-gap-xs"></div>
								<wa-button [routerLink]="['/plugins/datatables/data-table-page-configurator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DataTableOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Type-safe options class covering all DataTables configuration &mdash; paging, ordering, searching, AJAX, DOM layout, scrolling, state saving, and extensions</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">43 props</wa-tag>
									<wa-tag pill variant="neutral">25 methods</wa-tag>
									<wa-tag pill variant="success">3 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/datatables/data-table-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DataTableColumnOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Per-column configuration &mdash; data source, title, type, sortable, searchable, visible, width, render functions, and cell type</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">14 props</wa-tag>
									<wa-tag pill variant="neutral">13 methods</wa-tag>
									<wa-tag pill variant="success">2 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/datatables/data-table-column-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DataTablesResponsiveOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Responsive extension options &mdash; breakpoints, detail rendering, column priority for automatic column hiding on smaller screens</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">3 props</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/datatables/data-tables-responsive-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DataTablesButtonsOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Buttons extension options &mdash; export types &#40;Copy, Excel, PDF, CSV, Print&#41;, DOM placement, and custom button definitions</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">6 props</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/datatables/data-tables-buttons-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (17)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Multi-column sorting with custom sort types</p>
						<p waBody="s" waColorText="quiet" waText>Global and per-column filtering</p>
						<p waBody="s" waColorText="quiet" waText>Multiple pagination types &#40;simple, full, numbers&#41;</p>
						<p waBody="s" waColorText="quiet" waText>AJAX server-side processing with search DTOs</p>
						<p waBody="s" waColorText="quiet" waText>Responsive &mdash; auto-collapse columns on small screens</p>
						<p waBody="s" waColorText="quiet" waText>Buttons &mdash; export to PDF, Excel, CSV, copy, print</p>
						<p waBody="s" waColorText="quiet" waText>AutoFill &mdash; Excel-like click-and-drag cell filling</p>
						<p waBody="s" waColorText="quiet" waText>ColReorder &mdash; drag-and-drop column reordering</p>
						<p waBody="s" waColorText="quiet" waText>FixedColumns/FixedHeader &mdash; freeze columns and headers</p>
						<p waBody="s" waColorText="quiet" waText>KeyTable &mdash; keyboard navigation between cells</p>
						<p waBody="s" waColorText="quiet" waText>RowGroup &mdash; automatic grouping by column value</p>
						<p waBody="s" waColorText="quiet" waText>RowReorder &mdash; drag-and-drop row reordering</p>
						<p waBody="s" waColorText="quiet" waText>Scroller &mdash; virtual scrolling for large datasets</p>
						<p waBody="s" waColorText="quiet" waText>SearchPanes &mdash; faceted search panels</p>
						<p waBody="s" waColorText="quiet" waText>Select &mdash; row/column/cell selection</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe options &mdash; all as JSON-serializable Java classes</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (3)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Basic DataTable</h4>
							<p waBody="s" waColorText="quiet" waText>Create a sortable, searchable table with pagination.</p>
							<markdown [data]="mdContent_557" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Export Buttons</h4>
							<p waBody="s" waColorText="quiet" waText>Add PDF, Excel, and CSV export buttons.</p>
							<markdown [data]="mdContent_558" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Server-side Processing</h4>
							<p waBody="s" waColorText="quiet" waText>Enable AJAX with server-side search/sort/page.</p>
							<markdown [data]="mdContent_559" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_560" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (2)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>DataTablePageConfigurator auto-registers datatables.net, jszip, and pdfmake NPM dependencies</p>
						</div>
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IGuiceScanModuleInclusions</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>DataTablesInclusionModule ensures the DataTables module is included in Guice classpath scanning</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
							<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://www.datatables.net/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://datatables.net/manual/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/JWebMP</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>